// @ts-nocheck
import React from 'react'
import SectionTitleWithDivider from 'components/common/SectionTitleWithDivider'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
	margin-block-end: 20px;
`

const DealsSection = ({ title, children, testId, ...other }) =>
	!!children && (
		<Container {...other}>
			<SectionTitleWithDivider title={title} testId={testId} />
			{children}
		</Container>
	)

DealsSection.propTypes = {
	title: PropTypes.string,
	children: PropTypes.node,
}

export default DealsSection
